import DefaultConfirmButton_m from '@/game/prefabs/DefaultConfirmButton_m';
import DefaultButton from '@/game/prefabs/GeneralUI/Buttons/DefaultButton';
import DefaultDenyButton from '@/game/prefabs/GeneralUI/Buttons/DefaultDenyButton';
import DefaultDenyButton_m from '@/game/prefabs/GeneralUI/Buttons/DefaultDenyButton_m';
import HUDButton from '@/game/prefabs/GeneralUI/Buttons/HUDButton';
import UIBlocker from '@/game/prefabs/GeneralUI/UIBlocker';
import { NpcDialogueController } from '@/game/prefabs/WorldUI/NpcDialogue/NpcDialogueController';

/* START OF COMPILED CODE */

export default class npcDialogue extends Phaser.GameObjects.Container {

	constructor(scene: Phaser.Scene, x?: number, y?: number) {
		super(scene, x ?? 0, y ?? 0);

		// desktopView
		const desktopView = scene.add.container(0, 0);
		desktopView.visible = false;
		this.add(desktopView);

		// uIBlocker
		const uIBlocker = new UIBlocker(scene, 0, 0);
		desktopView.add(uIBlocker);

		// dialogueContainer
		const dialogueContainer = scene.add.container(0, 0);
		desktopView.add(dialogueContainer);

		// nineslice_1
		const nineslice_1 = scene.add.nineslice(0, 0, "Hud1", undefined, 144, 64, 8, 8, 8, 8);
		nineslice_1.scaleX = 4;
		nineslice_1.scaleY = 4;
		dialogueContainer.add(nineslice_1);

		// acceptButton
		const acceptButton = new DefaultButton(scene, -104, 80);
		acceptButton.scaleX = 1;
		acceptButton.scaleY = 1;
		dialogueContainer.add(acceptButton);

		// dialogueText
		const dialogueText = scene.add.bitmapText(-200, -28, "Aronui", "Let's match letters to their sounds in Mystic Match!");
		dialogueText.tintTopLeft = 5387071;
		dialogueText.tintTopRight = 5387071;
		dialogueText.tintBottomLeft = 5387071;
		dialogueText.tintBottomRight = 5387071;
		dialogueText.text = "Let's match letters to their sounds in Mystic Match!";
		dialogueText.fontSize = -24;
		dialogueText.maxWidth = 425;
		dialogueContainer.add(dialogueText);

		// cancelButton
		const cancelButton = new DefaultDenyButton(scene, 112, 80);
		dialogueContainer.add(cancelButton);

		// buttonsContainer
		const buttonsContainer = scene.add.container(232, -72);
		buttonsContainer.scaleX = 2;
		buttonsContainer.scaleY = 2;
		dialogueContainer.add(buttonsContainer);

		// duelButton
		const duelButton = new HUDButton(scene, 0, 0, "duel2");
		buttonsContainer.add(duelButton);

		// mobileView
		const mobileView = scene.add.container(0, 0);
		this.add(mobileView);

		// uIBlocker_m
		const uIBlocker_m = new UIBlocker(scene, 0, 0);
		mobileView.add(uIBlocker_m);

		// dialogueContainer_m
		const dialogueContainer_m = scene.add.container(0, 0);
		mobileView.add(dialogueContainer_m);

		// nineslice_m
		const nineslice_m = scene.add.nineslice(0, 0, "Hud1", undefined, 256, 112, 8, 8, 8, 8);
		nineslice_m.scaleX = 2;
		nineslice_m.scaleY = 2;
		dialogueContainer_m.add(nineslice_m);

		// dialogueText_m
		const dialogueText_m = scene.add.bitmapText(-200, -44, "Aronui", "Let's match letters to their sounds in Mystic Match!");
		dialogueText_m.tintTopLeft = 5387071;
		dialogueText_m.tintTopRight = 5387071;
		dialogueText_m.tintBottomLeft = 5387071;
		dialogueText_m.tintBottomRight = 5387071;
		dialogueText_m.text = "Let's match letters to their sounds in Mystic Match!";
		dialogueText_m.fontSize = -20;
		dialogueText_m.maxWidth = 425;
		dialogueContainer_m.add(dialogueText_m);

		// buttonsContainer_m
		const buttonsContainer_m = scene.add.container(256, -112);
		dialogueContainer_m.add(buttonsContainer_m);

		// duelButton_m
		const duelButton_m = new HUDButton(scene, -32, 32, "duel2");
		buttonsContainer_m.add(duelButton_m);

		// acceptButton_m
		const acceptButton_m = new DefaultConfirmButton_m(scene, -104, 64);
		dialogueContainer_m.add(acceptButton_m);

		// cancelButton_m
		const cancelButton_m = new DefaultDenyButton_m(scene, 112, 64);
		dialogueContainer_m.add(cancelButton_m);

		// acceptButton (prefab fields)
		acceptButton.buttonText = "Yes";

		// cancelButton (prefab fields)
		cancelButton.buttonText = "No";

		// duelButton (prefab fields)
		duelButton.useAlternateTextures = false;

		// duelButton_m (prefab fields)
		duelButton_m.useAlternateTextures = false;

		// acceptButton_m (prefab fields)
		acceptButton_m.buttonText = "Yes";

		// cancelButton_m (prefab fields)
		cancelButton_m.buttonText = "No";

		this.acceptButton = acceptButton;
		this.dialogueText = dialogueText;
		this.cancelButton = cancelButton;
		this.duelButton = duelButton;
		this.dialogueContainer = dialogueContainer;
		this.desktopView = desktopView;
		this.dialogueText_m = dialogueText_m;
		this.duelButton_m = duelButton_m;
		this.acceptButton_m = acceptButton_m;
		this.cancelButton_m = cancelButton_m;
		this.dialogueContainer_m = dialogueContainer_m;
		this.mobileView = mobileView;
		// awake handler
		this.scene.events.once("scene-awake", () => this.awake());

		/* START-USER-CTR-CODE */
    /* END-USER-CTR-CODE */
	}

	public acceptButton: DefaultButton;
	public dialogueText: Phaser.GameObjects.BitmapText;
	public cancelButton: DefaultDenyButton;
	public duelButton: HUDButton;
	public dialogueContainer: Phaser.GameObjects.Container;
	public desktopView: Phaser.GameObjects.Container;
	public dialogueText_m: Phaser.GameObjects.BitmapText;
	public duelButton_m: HUDButton;
	public acceptButton_m: DefaultConfirmButton_m;
	public cancelButton_m: DefaultDenyButton_m;
	public dialogueContainer_m: Phaser.GameObjects.Container;
	public mobileView: Phaser.GameObjects.Container;

	/* START-USER-CODE */
  public _controller?: NpcDialogueController;
  get controller() {
    return this._controller;
  }

  awake() {
    this._controller = new NpcDialogueController(this);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */
